import { useParams } from 'react-router-dom';

import { TextWithAudioReferences } from './text-with-audio-references';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/new/components/shadcn/dialog';

export function SummaryModal({ summary }: { summary: string }) {
  const { matterId, transcriptId } = useParams();
  if (!matterId || !transcriptId) return null;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button>
          <Icon className="lucide--file-text" />
          <span>View Transcript Summary</span>
        </Button>
      </DialogTrigger>

      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--file-text -mb-0.25 text-teal-500" />
            <span>Transcript Summary</span>
          </DialogTitle>
        </DialogHeader>

        <TextWithAudioReferences content={summary} matterId={matterId} transcriptId={transcriptId} />
      </DialogContent>
    </Dialog>
  );
}
